import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Expense, ExpenseCreate, ExpenseFilter } from '../data/expense';

export function createExpenseService(client: AxiosInstance) {
  return createCrudService<Expense, ExpenseCreate, ExpenseFilter>(client, '/Expense', 'expenseId');
}

export type ExpenseService = CrudService<Expense, ExpenseCreate, ExpenseFilter>;
